import { SymbolViewProps } from './SymbolModule.types';

export function SymbolView(props: SymbolViewProps) {
  return props.fallback;
}
